export enum TaxType {
    vat = 0
}